import { a } from './chunk-WWIKNET4.js';
import { e } from './chunk-HMNY52A3.js';

var d=class n{get newlyRecognizedBarcodes(){return this._newlyRecognizedBarcodes}get newlyLocalizedBarcodes(){return this._newlyLocalizedBarcodes}get frameSequenceID(){return this._frameSequenceID}static fromJSON(r){let e$1=new n;return e$1._newlyRecognizedBarcodes=r.newlyRecognizedBarcodes.map(o=>e.fromJSON(o)),e$1._newlyLocalizedBarcodes=r.newlyLocalizedBarcodes.map(o=>a.fromJSON(o)),e$1._frameSequenceID=r.frameSequenceId,e$1}};

export { d as a };
